import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { AccountService } from '../../../services/account.service';
import { UtilityService } from '../../../services/utility.service';
import { SubscriptionService } from '../../../services/subscription.service';
import { ISubscription } from '../../../interfaces/graph-types';
import { SubscriptionNotificationService } from '../../../services/subscription-notification.service';

@Component({
  selector: 'modify-subscription',
  template: require('./modify-subscription.component.pug'),
  styles: [require('./modify-subscription.component.css').toString()],
})
export class ModalModifySubscriptionComponent implements OnInit {
  // Options to pass to the modal:
  public reason: Subject<any>;

  accountId: string;
  plan: string = null;
  minInbox = 1;
  quantity = 1;
  cycle: string = '';
  subscription: ISubscription;
  discount: number = null;

  selectedPlan: string = null;

  // -------------------------------------------------------------------
  constructor(
    public bsModalRef: BsModalRef,
    private accountService: AccountService,
    private subscriptionService: SubscriptionService,
    private utilityService: UtilityService,
    private subscriptionNotificationService: SubscriptionNotificationService,
  ) {}

  // -------------------------------------------------------------------
  ngOnInit() {
    console.log(this.subscription)
    this.reason = new Subject();
    this.selectedPlan = this.subscription.name;
  }

  // -------------------------------------------------------------------
  onCancel() {
    this.bsModalRef.hide();
  }

  // -------------------------------------------------------------------
  private addInbox() {
    this.quantity = this.quantity + 1;
  }

  // -------------------------------------------------------------------
  private canRemoveInbox() {
    return this.minInbox < this.quantity;
  }

  // -------------------------------------------------------------------
  private removeInbox() {
    this.quantity = this.quantity - 1;
    if (this.quantity < 1) {
      this.quantity = 1;
    }
  }

  // -------------------------------------------------------------------
  private getPrice(plan) {
    const price = this.utilityService.getPricing(plan, this.quantity, this.cycle);

    return this.utilityService.formatPrice(price, this.cycle);
  }

  // -------------------------------------------------------------------
  private getPriceWithDiscount(plan) {
    const price = this.utilityService.getPricing(plan, this.quantity, this.cycle);

    const withDiscount = this.utilityService.getPricingWithDiscount(price, this.discount);
    
    return this.utilityService.formatPrice(withDiscount, this.cycle);
  }

  private errorText: string = null;
  // -------------------------------------------------------------------
  updateSubscription(
    data: any,
    onsuccess: onSmartSuccess,
    onfailure: onSmartFailure,
  ) {
    const plan = this.selectedPlan === this.subscription.name ? null : this.selectedPlan;

    this.errorText = null;
    this.subscriptionService.updateSubscription(
      this.accountId,
      this.quantity,
      plan,
      this.cycle,
      () => {
        this.subscriptionNotificationService.planName.next(this.selectedPlan);
        this.reason.next(true);
        this.bsModalRef.hide();
      },
      error => {
        this.errorText = error;
        onfailure(error);
      },
    );
  }

  // -------------------------------------------------------------------
  selectPlan(plan) {
    if (plan !== this.selectedPlan) {
      this.errorText = null;
    }
    this.selectedPlan = plan;
  }

  // -------------------------------------------------------------------
  isDisabled() {
    // if (this.selectedPlan == 'sleep' && this.cycle == 'yearly') return true;
    if (this.selectedPlan == 'sleep' && this.plan == 'sleep') return true;

    return false;
  }
}
